<template>
  <v-container fluid>
    <v-row column>
      <p class="body-text-1" v-if="!minorAccountsNotLinked?.length">
        {{ $t('mal_the_minor_account_have_been_linked_successfully') }}
      </p>
      <p class="body-text-1" v-else>
        {{ $t('mal_some_minor_accounts_below_linked_successfully') }}
      </p>
      <p class="body-text-1 mb-4">{{ $t('mal_you_will_now_see_the_balance') }}</p>
      <div v-for="account in minorAccountsLinked" :key="account.accountId">
        <v-icon class="left-icon" color="success" :icon="mdiCheck" />
        {{ account.accountNumber }}&nbsp;&nbsp;&nbsp;&nbsp;{{ account.firstName }}&nbsp;{{
          account.lastName
        }}<br />
      </div>
      <div v-if="minorAccountsNotLinked?.length" class="py-4">
        <p>
          {{ $t('mal_however_the_following_accounts_were_not_linked') }}
        </p>
        <div v-for="account in minorAccountsNotLinked" :key="account.accountId">
          <v-icon class="left-icon" color="error" :icon="mdiPriorityHigh" />
          {{ account.accountNumber }}&nbsp;&nbsp;&nbsp;&nbsp;{{ account.firstName }}&nbsp;{{
            account.lastName
          }}<br />
        </div>
      </div>
      <v-row class="mt-4 justify-end">
        <v-col cols="12" sm="4" class="text-center">
          <OnexButton :disabled="disableActions" color="primary" @click="continueAction">
            OK
          </OnexButton>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { type ComponentOptions, defineComponent, type PropType } from 'vue';
import { mdiPriorityHigh, mdiCheck } from '@mdi/js';
import { OnexButton } from '@primerica/onex-ui-lib';
import type { ICustodialAccountMeta } from '@/shared/api/models.bff';

export default defineComponent({
  name: 'MinorAccountLinkProcessLinkConfirmation',
  components: {
    OnexButton,
  },
  props: {
    minorAccountsLinked: {
      type: Array as PropType<ICustodialAccountMeta[]>,
      required: true,
    },
    minorAccountsNotLinked: {
      type: Array as PropType<ICustodialAccountMeta[]>,
      required: true,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    mdiPriorityHigh,
    mdiCheck,
  }),
  computed: {},
  methods: {
    continueAction() {
      this.$emit('continueClicked', {});
    },
    cancelAction() {
      this.$emit('cancelClicked');
    },
  },
} as ComponentOptions);
</script>
